import React from 'react';
import { ResponseCard, ResponseCardProps } from '@cp/entities/response';
import { CatalogItemResponseViewModel } from '@common/model/catalog/item/response';
import { OnlineStatusMarker } from '@cp/ds/src/components/onlineStatus';
import { Avatar } from '@cp/ds/src/components/avatar';
import { Box } from '@cp/ds/src/components/box';
import { coreDialogApi, formatMessageDate, getMessageDescription } from '@cp/entities/dialog';
import { MessageContent } from '@cp/ds/src/components/messageContent';

export interface ResponseCardFeatureProps extends Omit<ResponseCardProps, 'title' | 'respondedAt'> {
  model: CatalogItemResponseViewModel;
  onActivate?: (model: CatalogItemResponseViewModel) => void;
}

export const ResponseCardFeature: React.FC<ResponseCardFeatureProps> = ({ model, onActivate, ...props }) => {
  const { data: dialog } = coreDialogApi.endpoints.getDialog.useQuery({ id: model.dialogId });

  return (
    <ResponseCard
      avatar={
        <Box sx={{ position: 'relative' }}>
          <Avatar content={{ image: model.respondent.mainPhoto?.image }} rounded size={48} />
          <OnlineStatusMarker online={model.respondent.isOnline} sx={{ position: 'absolute', top: 0, right: 0, zIndex: 1 }} />
        </Box>
      }
      component="li"
      description={dialog?.lastMessage && <MessageContent content={getMessageDescription(dialog.lastMessage)} textOnly />}
      onClick={() => onActivate?.(model)}
      respondedAt={formatMessageDate(model.createdAt)}
      title={model.respondent.name}
      {...props}
    />
  );
};
